/**
 * Handle post-purchase GTM event.
 */
class IconicGTMPurchase {
	/**
	 * Check is purchase response is a trial.
	 *
	 * @param response
	 * @returns {boolean}
	 */
	static responseIsTrial = ( response ) => {
		// If no purchase info is set.
		if ( typeof response.purchase === 'undefined' ) {
			return true;
		}

		// If this is a trial which requires card details.
		return typeof response.purchase.trial_ends !== 'undefined' && response.purchase.trial_ends !== null;
	};

	/**
	 * Get purchase response total.
	 *
	 * @param response
	 * @returns {number}
	 */
	static responseGetTotal = ( response ) => {
		let trial = IconicGTMPurchase.responseIsTrial( response );

		if ( trial ) {
			return 0;
		}

		return typeof response.purchase.initial_amount !== 'undefined' ? parseFloat( response.purchase.initial_amount.toString() ) : parseFloat( response.purchase.gross.toString() );
	};

	/**
	 * Get purchase response plugin ID.
	 *
	 * @param response
	 * @returns {string}
	 */
	static responseGetPluginId = ( response ) => {
		let plugin_id = response.purchase.plugin_id.toString();

		// If is bundle, add plan to plugin ID.
		if ( '1829' === plugin_id ) {
			plugin_id += '-' + response.purchase.plan_id.toString();
		}

		return plugin_id;
	};

	/**
	 * Get purchase response transaction ID.
	 *
	 * @param response
	 * @returns {string|boolean}
	 */
	static responseGetTransactionId = ( response ) => {
		// Use purchase ID when available.
		if ( typeof response.purchase !== 'undefined' ) {
			return response.purchase.id.toString();
		}

		// Otherwise, generate an ID based on the time of the transaction.
		// Required for trials with no payment method, at the moment.
		if ( typeof response.plan !== 'undefined' ) {
			let now = new Date(),
				now_utc = new Date( now.toUTCString().slice( 0, - 4 ) ),
				date = now_utc.getFullYear() + '-' + (now_utc.getMonth() + 1) + '-' + now_utc.getDate(),
				time = now_utc.getHours() + ":" + now_utc.getMinutes() + ":" + now_utc.getSeconds();

			return date + ' ' + time + ' ' + response.plan.plugin_id.toString();
		}

		return false;
	};

	/**
	 * Get the plan ID.
	 *
	 * @param response
	 * @return {string|boolean}
	 */
	static responseGetPlanId = ( response ) => {
		if ( typeof response.purchase !== 'undefined' ) {
			return response.purchase.plan_id.toString();
		}

		if ( typeof response.plan !== 'undefined' ) {
			return response.plan.id.toString();
		}

		return false;
	};

	/**
	 * Get the license ID.
	 *
	 * @param response
	 * @return {string|int}
	 */
	static responseGetLicenseId = function( response ) {
		if ( typeof response.purchase === 'undefined' || typeof response.purchase.license_id === 'undefined' ) {
			return 0;
		}

		return response.purchase.license_id;
	};

	/**
	 * Push sale to data layer.
	 */
	static dataLayerPush = ( response, title ) => {
		let trial = IconicGTMPurchase.responseIsTrial( response ),
			event_type = trial ? 'trial' : 'purchase',
			total = IconicGTMPurchase.responseGetTotal( response ),
			plugin_id = IconicGTMPurchase.responseGetPluginId( response );

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push( {
			'event': 'iconic.' + event_type,
			'name': title,
			'transactionId': IconicGTMPurchase.responseGetTransactionId( response ),
			'transactionTotal': total,
			'trial': trial,
			'currencyCode': 'USD',
			'transactionProducts': [
				{
					'sku': plugin_id,
					'name': title,
					'price': total,
					'quantity': 1
				}
			]
		} );
	}
}

export {IconicGTMPurchase};